<template>
  <div class="bookviews">
    <img src="data:image/svg+xml;base64,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" alt="" class="view">
    <span>{{ formatNum(view) }}</span>
  </div>
</template>

<script>
import {nFormatter} from "@/utils/utils.ts";

export default {
  name: "RateMask",
  props: ["view"],
  methods: {
    formatNum(num) {
      return num ? nFormatter(num) : 0;
    }
  }
}
</script>

<style scoped lang="scss">
.bookviews {
  position: absolute;
  left: 0;
  bottom: 0;
  padding-right: 5px;
  padding-left: 2px;
  height: 14px;
  background: #000;
  border-radius: 0 8px 0 0;
  opacity: .8;
  display: flex;
  align-items: center;
  .view {
    width: 12px;
    flex-shrink: 0;
    margin-right: 1px;
  }
  span {
    font-size: 9px;
    font-family: Poppins-Medium,Poppins;
    font-weight: 500;
    color: #fff;
  }
}
</style>
